module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('icon', {
    staticClass: "x-flag__times-circle",
    attrs: {
      "name": "times-circle",
      "scale": _vm.scale
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed8d2eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/xFlag/XFlag.vue
// module id = 1888
// module chunks = 0